import React from "react"

import { injectIntl } from "react-intl"
import { Button } from "react-bootstrap"

import { withSampleConfig } from "../../../config/SampleConfigProvider"

function CancelMethodButton({
  isHistorical,
  methodInfo,
  name,
  smpID,
  isLoading = false,
  onSuccess,
  onError,
  extraStyle = {},
  reloadSampleRoundsTable, // From SampleConfigProvider
  reloadSampleTable, // From SampleConfigProvider
  updateSampleMethod, // From SampleConfigProvider
  user_permissions = [], // From SampleConfigProvider
  intl, // From injectIntl
}) {
  const alterMethodStatus = (method, isCancellation) => {
    if (isCancellation) {
      if (
        !confirm(
          `${intl.formatMessage({
            id: "samplemanagement.confirm.method.cancellation",
          })}: ${method}`,
        )
      ) {
        return false
      }
    }

    updateSampleMethod(
      smpID,
      method,
      isCancellation ? "not_analyzed" : "pending_analysis",
      () => {
        if (onSuccess) {
          onSuccess()
        } else {
          reloadSampleRoundsTable()
          reloadSampleTable()
        }
      },
      () => {
        alert(
          intl.formatMessage({
            id: "samplemanagement.error.unable.to.update.method",
          }),
        )
        onError && onError()
      },
    )
  }

  return (
    <>
      {methodInfo?.status === "pending_analysis" ? (
        <Button
          style={extraStyle}
          variant={"outline-primary"}
          className={"btn btn-sm"}
          disabled={
            methodInfo?.slims_method ||
            isHistorical ||
            isLoading ||
            !user_permissions.includes("change_sampleround")
          }
          onClick={(e) => {
            e.stopPropagation()
            alterMethodStatus(name, true)
          }}
        >
          <span className={"fa fa-exclamation-triangle text-danger"} />
          &nbsp;
          <span className={"text-danger"}>{intl.formatMessage({ id: "general.cancelButton" })}</span>
        </Button>
      ) : (
        methodInfo?.status === "not_analyzed" && (
          <Button
            style={extraStyle}
            variant={"outline-primary"}
            className={"btn btn-sm"}
            disabled={
              methodInfo?.slims_method ||
              isHistorical ||
              isLoading ||
              !user_permissions.includes("change_sampleround")
            }
            onClick={(e) => {
              e.stopPropagation()
              alterMethodStatus(name, false)
            }}
          >
            <span className={"fa fa-refresh text-success"} />
            &nbsp;
            <span className={"text-success"}>{intl.formatMessage({ id: "general.restore" })}</span>
          </Button>
        )
      )}
    </>
  )
}

export default injectIntl(withSampleConfig(CancelMethodButton))
